const routes = [
  { name: "Home", path: "/" },
  { name: "About", path: "/about/" },
  { name: "Portfolio", path: "/portfolio/" },
  { name: "Blog", path: "/blog/" },
  { name: "Contact", path: "/contact/" },
]

export default routes
